<mat-form-field>
    <mat-select placeholder="Raum wechseln" [formControl]="roomControl">
      <!-- <mat-option>-- Kein Raum ausgewählt --</mat-option> -->
      <mat-optgroup *ngFor="let location of locations" [label]="location.name">
        <mat-option *ngFor="let room of location.rooms; let i = index" [value]="room">
          {{ room['name'] }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>